import { getFragmentData, graphql } from 'client/gql';
import {
  AbsenceEvaluationClassesTable,
  AbsenceEvaluationClassesTableFragment,
} from 'components/Absences/tables/AbsenceEvaluationClassesTable';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { OrganizationConfigContext } from 'context/OrganizationConfigContext';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'urql';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { useStackHandler } from '../../../hooks/useStackHandler';
import { AbsencesEvaluationClassSubpage } from './AbsencesEvaluationClassSubpage';

const AbsencesEvaluationSubpageQuery = graphql(`
  query AbsencesEvaluationSubpageData($classesWhere: ClassWhere) {
    ...AbsenceEvaluationClassesTableFields
  }
`);

export const AbsencesEvaluationSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();
  const { currentSchoolYear } = useContext(OrganizationConfigContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isDesktop = useIsDesktop();
  const stackHandler = useStackHandler();

  const [{ data }] = useQuery({
    query: AbsencesEvaluationSubpageQuery,
    variables: {
      classesWhere: {
        organization: { uuid: organization.uuid },
        schoolYear: { uuid: currentSchoolYear.uuid },
      },
    },
  });

  const permissions = usePermissionChecker();

  return (
    <BpSubpage isForbidden={!permissions?.canViewAbsencesEvaluation()}>
      <AbsenceEvaluationClassesTable
        onNavigate={(classUuid) => {
          if (isDesktop) {
            navigate(`/absences/evaluation/${classUuid}`);
          } else {
            const fragment = getFragmentData(AbsenceEvaluationClassesTableFragment, data);
            const selectedClass = fragment?.classes.find((c) => c.uuid === classUuid);

            stackHandler.push({
              id: `absences-evaluation-${classUuid}`,
              title: t('absences.evaluation.classTitle', { className: selectedClass?.name ?? '' }),
              group: 'absences',
              component: <AbsencesEvaluationClassSubpage />,
            });
          }
        }}
        query={data}
      />
    </BpSubpage>
  );
};
